const INVALID_CREDENTIALS_MESSAGE =
  "メールアドレスまたはパスワードが正しくありません。";
const RATE_LIMIT_MESSAGE =
  "リクエストが多すぎます。しばらく時間をおいてから再度お試しください。";
const GENERIC_LOGIN_ERROR_MESSAGE =
  "ログインに失敗しました。時間をおいて再度お試しください。";
const ACCOUNT_LOCK_MESSAGE_PREFIX = "アカウントが一時的にロックされています。";

type ApiErrorResponse = {
  response?: {
    status?: number;
    data?: { message?: string | string[] };
  };
};

const getApiMessage = (error: unknown): string | undefined => {
  const message = (error as ApiErrorResponse)?.response?.data?.message;
  if (Array.isArray(message)) {
    return message[0];
  }
  return typeof message === "string" && message.length > 0
    ? message
    : undefined;
};

/**
 * ログインAPIの内部メッセージを、そのまま利用者へ露出しないための変換処理。
 * アカウントの存在有無を推測できないよう、通常の401は常に同じ文言にする。
 */
export const getStaffLoginErrorMessage = (error: unknown): string => {
  const response = (error as ApiErrorResponse)?.response;
  const apiMessage = getApiMessage(error);

  if (response?.status === 401) {
    if (apiMessage?.startsWith(ACCOUNT_LOCK_MESSAGE_PREFIX)) {
      return apiMessage;
    }
    return INVALID_CREDENTIALS_MESSAGE;
  }

  if (response?.status === 429) {
    return RATE_LIMIT_MESSAGE;
  }

  return GENERIC_LOGIN_ERROR_MESSAGE;
};
